import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSettingsGearFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.753 21.5h-1.509a2.595 2.595 0 0 1-2.592-2.593.63.63 0 0 0-.32-.555.63.63 0 0 0-.64 0c-.6.346-1.3.439-1.969.259a2.57 2.57 0 0 1-1.574-1.208l-.754-1.306a2.596 2.596 0 0 1 .95-3.542.63.63 0 0 0 .32-.555.63.63 0 0 0-.32-.556 2.594 2.594 0 0 1-.95-3.54l.755-1.307a2.58 2.58 0 0 1 1.573-1.208 2.58 2.58 0 0 1 1.968.258.63.63 0 0 0 .64.001.63.63 0 0 0 .321-.555A2.595 2.595 0 0 1 11.244 2.5h1.51a2.596 2.596 0 0 1 2.592 2.593c0 .334.225.5.321.555a.63.63 0 0 0 .64 0 2.57 2.57 0 0 1 1.968-.259 2.58 2.58 0 0 1 1.574 1.208l.754 1.306c.346.6.438 1.298.26 1.968a2.58 2.58 0 0 1-1.209 1.574.63.63 0 0 0-.32.555.63.63 0 0 0 .32.555 2.58 2.58 0 0 1 1.208 1.575 2.58 2.58 0 0 1-.259 1.967l-.754 1.306a2.594 2.594 0 0 1-3.542.949.63.63 0 0 0-.64 0 .63.63 0 0 0-.32.555 2.596 2.596 0 0 1-2.594 2.593m-.755-12.713a3.212 3.212 0 1 1 .001 6.425 3.212 3.212 0 0 1-.001-6.425"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSettingsGearFilled);
export default ForwardRef;
